module.exports = __webpack_public_path__ + "img/science.127f5d69.webp";